import { useCallback, useEffect, useRef, useState } from 'react';

import { useTranslation } from 'react-i18next';

import { ReactComponent as UploadIcon } from 'assets/icons/upload-icon.svg';

import Button from '../Button/Button';
import styles from './DragAndDrop.module.css';

interface iProps {
  variaty: 'single' | 'multiple';
  accept: string;
  onDrop: (files: any[]) => void;
}

//Upload Student Documents (PDF or Word)
export default (props: iProps) => {
  const { t } = useTranslation();
  const [isDragging, setIsDragging] = useState(false);
  const input = useRef(null);
  const handleDrag = useCallback(e => {
    e.preventDefault();
    e.stopPropagation();
    if (e.type === 'dragenter' || e.type === 'dragover') {
      setIsDragging(true);
    } else if (e.type === 'dragleave') {
      setIsDragging(false);
    }
  }, []);

  const handleDrop = useCallback(e => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);

    const droppedFiles = Array.from(e.dataTransfer.files);
    props.onDrop(droppedFiles);
  }, []);
  const handleFileSelect = e => {
    const selectedFiles = Array.from(e.target.files);

    props.onDrop(selectedFiles);
  };
  return (
    <div className={styles.container}>
      <label
        className={`${styles.dropzone} ${isDragging ? styles.dragging : ''}`}
        onDragEnter={handleDrag}
        onDragOver={handleDrag}
        onDragLeave={handleDrag}
        onDrop={handleDrop}
        htmlFor="fileInput"
      >
        <input
          id="fileInput"
          type="file"
          multiple={props.variaty === 'multiple'}
          accept={props.accept}
          className={styles.fileInput}
          onChange={handleFileSelect}
        />
        <p className={styles.dropzoneText}>
          {isDragging ? 'Drop files here' : 'Drag and drop files here, or click to select'}
        </p>
      </label>
    </div>
  );
};
